import Hammer from "hammerjs";
import Rellax from "rellax";

(function() {
  'use strict';

  document.addEventListener("DOMContentLoaded", function() {

    let vh = window.innerHeight * 0.01;
    let viewportHeight = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
      // We execute the same script as before
      vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      viewportHeight = window.innerHeight;
    });


    if(document.querySelector("body").className==="quiz"){
    const person_Data = [
      {
          id: 1,
          nom: "Nicolas",
          bg: "Nicolas",
          image: "./assets/images/front/character/nico.png",
          role: "Directeur et fondateur",
      },
      {
          id: 2,
          nom: "Anaïs",
          bg: "Anaïs",
          image: "./assets/images/front/character/anais.png",
          role: "Chef de projet",
      },
        {
          id: 3,
          nom: "Alizée",
          bg: "Alizée",
          image: "./assets/images/front/character/alizee.png",
          role: "Designer UI/UX",
      },
        {
          id: 4,
          nom: "Amélie",
          bg: "Amélie",
          image: "./assets/images/front/character/amelie.png",
          role: "Designer UI/UX",
      },
        {
          id: 5,
          nom: "Marion",
          bg: "Marion",
          image: "./assets/images/front/character/marion.png",
          role: "Responsable conseil et développement",
      },
      {
          id: 6,
          nom: "Justine",
          bg: "Justine",
          image: "./assets/images/front/character/justine.png",
          role: "UX Researcher",
      },
      {
          id: 7,
          nom: "Damien",
          bg: "Damien",
          image: "./assets/images/front/character/damien.png",
          role: "Designer UI/UX",
      },
        {
          id: 8,
          nom: "Guillaume",
          bg: "Guillaume",
          image: "./assets/images/front/character/guillaume.png",
          role: "Chef de projet",
      },
        {
          id: 9,
          nom: "Matthis",
          bg: "Matthis",
          image: "./assets/images/front/character/matthis.png",
          role: "Développeur front-end",
      },
        {
          id: 10,
          nom: "Gauthier",
          bg: "Gauthier",
          image: "./assets/images/front/character/gauthier.png",
          role: "Développeur front-end",
      },
        {
          id: 11,
          nom: "Aimerick",
          bg: "Aimerick",
          image: "./assets/images/front/character/aimerick.png",
          role: "Développeur back-end",
      },
      {
          id: 12,
          nom: "Luisa",
          bg: "Luisa",
          image: "./assets/images/front/character/luisa.png",
          role: "Chef de projet",
      },
      {
          id: 13,
          nom: "Sandrine",
          bg: "Sandrine",
          image: "./assets/images/front/character/sandrine.png",
          role: "Développeuse back-end",
      },
      {
        id: 14,
        nom: "Sandrine",
        bg: "Sandrine",
        image: "./assets/images/front/character/sandrine.png",
        role: "Développeuse back-end",
    },
        {
          id: 15,
          nom: "Aurore",
          bg: "Aurore",
          image: "./assets/images/front/character/aurore.png",
          role: "Chef de projet",
      },
        {
          id: 16,
          nom: "Manuel",
          bg: "Manuel",
          image: "./assets/images/front/character/manuel.png",
          role: "Développeur front-end",
      },
        {
          id: 17,
          nom: "Guirec",
          bg: "Guirec",
          image: "./assets/images/front/character/guirec.png",
          role: "UX Writer",
      },
      {
          id: 18,
          nom: "Benoit",
          bg: "Benoit",
          image: "./assets/images/front/character/benoit.png",
          role: "UX Researcher",
      },
      {
          id: 19,
          nom: "Cédric",
          bg: "Cédric",
          image: "./assets/images/front/character/cedric.png",
          role: "Développeur back-end",
      },
      {
          id: 20,
          nom: "Arnaud",
          bg: "Arnaud",
          image: "./assets/images/front/character/arnaud.png",
          role: "UX / UI Designer",
      },
      {
          id: 21,
          nom: "Maéva",
          bg: "Maéva",
          image: "./assets/images/front/character/maeva.png",
          role: "Chef de projet",
      },
        {
          id: 22,
          nom: "Erika",
          bg: "Erika",
          image: "./assets/images/front/character/erika.png",
          role: "UX / UI Designer",
      },
        {
          id: 23,
          nom: "Christina",
          bg: "Christina",
          image: "./assets/images/front/character/christina.png",
          role: "Développeuse front-end",
      },
        {
          id: 24,
          nom: "Aimerick et Guillaume",
          bg: "Team Support",
          image: "./assets/images/front/character/aimerick-et-guillaume.png",
          role: "Développeur back-end et Chef de projet",
      },
      {
        id: 25,
        nom: "Marion et Anaïs",
        bg: "Acolytes",
        image: "./assets/images/front/character/marion-et-anais.png",
        role: "Responsable conseil et développement et Chef de projet",
    },
    {
      id: 26,
      nom: "Justine et Octave",
      bg: "Inséparables",
      image: "./assets/images/front/character/justine-et-octave.png",
      role: "UX Researcher et Happiness Manager",
  },
  {
    id: 27,
    nom: " Pascale",
    bg: " Pascale",
    image: "./assets/images/front/character/pascale.png",
    role: "Responsable RH et financier",
},

    ]
    const quiz_Data = [
        {
            question: "Qui cache soigneusement <span>tous les câbles</span> qui dépassent avant votre venue ?",
            a: 1,
            b: 3,
            c: 27,
            correct: "a",
            texta:"S’il est le Directeur de l’agence, il est aussi le Directeur de l’ordre électrique visuel (Chief Visual Cable Officer comme on ne dit pas). Si l’agence est si élégante, il n’y est pas étranger.",
            textb:"Aussi connue à l’agence sous le titre de “Brigade du style”, elle apprécie que les locaux soient clean pour nous préparer de super shoots Instagram. Mais pour autant, elle n’est pas notre rangeuse de câbles compulsive. Désolés.",
            textc:"C'est vrai que Pascale est aussi la reine du rangement. Mais son dada à elle c'est plutôt de nous aider nous à bien nous organiser, à tirer profit du meilleur du collectif. Notre reine de la bienveillance à nous.",
            icon:"sprite-cable",

        },
        {
            question : "Qui pousse <span>la chansonnette</span> quand il prépare ses benchmarks aux petits oignons ?",
            a: 10,
            b: 7,
            c: 18,
            correct: "b",
            texta:"Bien que chanteur dans un groupe de métal, il est compliqué de profiter de la douce voix de Gauthier depuis Colmar.",
            textb:"Au début, on le regarde de travers. Et puis quand il passe à Céline Dion bizarrement il n’est plus tout seul à chanter et le son monte d’un cran. Mais chut, ça c’est notre petit secret inavouable. ",
            textc:"Benoit nous a démontré son goût du karaoké. Pourtant au bureau il a la vocalise bien plus discrète que notre champion.",
            icon:"sprite-micro",
        },
          {
            question : "Qui est notre nouveau <span>duo de choc</span>, le binôme de l’agence ?",
            a: 26,
            b: 25,
            c: 24,
            correct: "c",
            texta:"Bien plus qu’un duo de choc, Octave est officiellement devenu notre mascotte ! ",
            textb:"Ok, elles aussi réclament toujours à travailler ensemble, mais, à l’inverse de notre duo de choc, elles n’ont pas d’excuse valable.",
            textc:"Depuis qu’ils ont créé la Team Support LW, ils sont un peu devenus nos Omar et Fred à nous. Inséparables, comme les doigts de la main, pour toujours mieux vous servir. ",
            icon:"sprite-duo"
        },
        {
          question : "Qui se donne tellement à fond sur vos projets que tous les midis elle nous tanne pour <span>jouer au Ligretto</span> ?",
          a: 13,
          b: 22,
          c: 4,
          correct: "c",
          texta:"Au début, cela aurait pu être Sandrine, en effet. Mais trop de Ligretto tue le Ligretto, il arrive même qu’elle essaye de s’esquiver pour y échapper.",
          textb:"C’est aussi une grande fan des jeux de société mais malheureusement, à celui-ci, elle n’arrive pas à la cheville de notre championne.",
          textc:"Bingo ! Et heureusement que vous ne voyez pas cela, vous ne la reconnaîtriez pas.",
          icon:"sprite-ligretto"
      },
      {
        question : "Qui est notre <span>grand fondu de raclette</span>, une fois une bonne journée terminée ?",
        a: 9,
        b: 23,
        c: 20,
        correct: "a",
        texta:"Notre champion de Limbo ultra souple (on vous racontera) est, contrairement aux apparences, souvent trompeuses, un obsessionnel de la raclette. Il a développé des techniques personnelles incroyables pour parvenir à en manger des quantités fabuleuses.",
        textb:"Bien qu’elle apprécie la raclette, Christina ne renie pas ses origines et compte bien nous faire tous passer à la raclette version Allemande avec bien plus de choses saines dedans. 2022 s’annonce pleine de défis incroyables !",
        textc:"Trop occupé à faire tourner son postiche de nuque longue pendant le repas, Arnaud voit bien trop de poêlons lui passer sous le nez. Dommage, nous “fondions” tant d’espoir sur lui.",
        icon:"sprite-raclette"
    },
  {
    question : "Qui se donne toujours l’excuse de l’atelier client du matin pour amener des <span>viennoiseries au bureau</span> ?",
    a: 15,
    b: 21,
    c: 12,
    correct: "b",
    texta:"Presque ! Mais Aurore son petit truc à elle c’est plutôt les tablettes de chocolat qu’elle amène aux réunions hebdo des chefs de projets.",
    textb:"Notre dernière recrue chez les chefs de projets, elle a plus d’une corde à son arc. Notre préférée : toujours faire un petit crochet par la boulangerie avant un atelier pour chouchouter ses clients.",
    textc:"Côté gastronomie, Luisa c’est plutôt les légumes de l’Amap du coin. Du coup, on lui a gentiment demandé de ne pas amener de quoi grignoter pour les ateliers… On s’est dit que ce serait quand même étrange une fondue de poireaux à partager, non ?",
    icon:"sprite-donut"
},
{
  question : "Qui a le don pour toujours être là <span>où on ne l’attend pas</span> ?",
  a: 19,
  b: 17,
  c: 16,
  correct: "c",
  texta:"La tête dans le guidon, ultra-concentré sur le développement de ses projets en cours, Cédric reste plutôt focus. Mais ça, c’est peut-être parce qu’il nous a rejoint il y a quelques mois seulement… Viendra-t-il bientôt concurrencer notre roi du photobomb ?",
  textb:"S’il n’est pas en interview client, il s’attèle secrètement à la préparation de nouveaux ateliers d’UX Writing avec quelques membres de l’équipe… Que sont-ils en train de nous préparer pour ce tout nouveau métier de l’Agence ? 2022 nous le dira ! ",
  textc:"Irrésistiblement attiré par toute forme d’objectif photographique, Manu est le ninja du photobomb. Il est devenu tellement doué que nous allons lui écrire une recommandation Linkedin au sujet de cette compétence.",
  icon:"sprite-camera"
},
    ]

    let $optionBox = document.querySelector(".o-cluster");
    let $infoBoxQuestion = document.querySelector(".c-infoBox__question");
    let $infoBoxImage = document.querySelector(".c-infoBox__image");

    let $levelInfo = document.querySelector(".c-header__level");

    let $infoBoxRound = document.querySelector(".c-infoBox__round");

    let $overlay = document.querySelector(".l-overlay");
    let $popUp = document.querySelector(".c-popUp");
    let $popUpHeadline = document.querySelector(".c-popUp__headline");
    let $popUpName = document.querySelector(".c-popUp__name");
    let $popUpText = document.querySelector(".c-popUp__text");
    let $popUpButton = document.querySelector(".c-popUp__button");
    let $startAnimations;

    let $options;

    let $buttonNext=document.querySelector(".js-button--next");
    let $buttonPrev=document.querySelector(".js-button--prev");

    let $buttonValide=document.querySelector(".button--valide");
    let $buttonSkipQuestion=document.querySelector(".js-skip-question");

    let currentQuiz = 0;
    let totalQuiz;
    let currentQuizData = quiz_Data[currentQuiz];
    const personData = person_Data;
    let number;
    let numberNext;
    let numberPrev;

    let selectedId;
    let selectedPersonId;
    let $selectedElement;

    let feedback;

    mount();

    function createList(){
      let clone0Element= document.createElement("div");
      clone0Element.setAttribute("class", "c-deco has-startAnimation");
      $optionBox.appendChild(clone0Element);
      let clone1Element= document.createElement("li");
      clone1Element.setAttribute("class", "c-option hide");
      clone1Element.setAttribute("id", "c");
      $optionBox.appendChild(clone1Element);
      let clone2Element= document.createElement("li");
      clone2Element.setAttribute("class", "c-option prev");
      clone2Element.setAttribute("id", "a");
      $optionBox.appendChild(clone2Element);
      let clone3Element= document.createElement("li");
      clone3Element.setAttribute("class", "c-option act");
      clone3Element.setAttribute("id", "b");
      $optionBox.appendChild(clone3Element);
      let clone4Element= document.createElement("li");
      clone4Element.setAttribute("class", "c-option next");
      clone4Element.setAttribute("id", "c");
      $optionBox.appendChild(clone4Element);
      let clone5Element= document.createElement("li");
      clone5Element.setAttribute("class", "c-option next new-next");
      clone5Element.setAttribute("id", "a");
      $optionBox.appendChild(clone5Element);
    }

    function clear(){
      number="b";
      //$optionBox
      $optionBox.innerHTML="";

      createList();

      $options=document.querySelectorAll(".c-option");
    }

    function populated($option,createLetter){
      selectedPersonId = currentQuizData[createLetter];
      //load new info
      $option.id=createLetter;
      $option.style.backgroundImage = "url('"+personData[selectedPersonId-1].image+"')";
      $option.setAttribute("role", "img");
      $option.setAttribute("aria-label", personData[selectedPersonId-1].nom);

      $startAnimations = document.querySelectorAll(".has-startAnimation");

      for (var i = 0; i < $startAnimations.length; i++){
        let $startAnimation = $startAnimations[i];

        $startAnimation.style.animation = 'none';
        resetAnimation($startAnimation);
      }

      function resetAnimation($startAnimation) {
        setTimeout(function() {
          $startAnimation.style.animation = '';
        }, 10);
      }
    }


    function getSelection(){
      selectedId=document.querySelector(".act").id;
      selectedPersonId = currentQuizData[selectedId];

      document.querySelector(".c-deco").innerHTML=person_Data[selectedPersonId-1].bg;
      $buttonValide.innerHTML="Choisir "+person_Data[selectedPersonId-1].nom;

      $buttonNext.querySelector("p").innerHTML= "<span>"+person_Data[currentQuizData[document.querySelector(".next").id]-1].nom + "</span><span>"+person_Data[currentQuizData[document.querySelector(".next").id]-1].role+"</span>";
      $buttonPrev.querySelector("p").innerHTML= "<span>"+person_Data[currentQuizData[document.querySelector(".prev").id]-1].nom + "</span><span>"+person_Data[currentQuizData[document.querySelector(".prev").id]-1].role+"</span>";
    }

    function mount(){

      clear();
      currentQuizData = quiz_Data[currentQuiz];
      totalQuiz=Object.keys(quiz_Data).length;

      $levelInfo.innerHTML='<span class="c-header__level__courrent">'+(currentQuiz+1) +' </span>/ <span class="c-header__level__total">'+totalQuiz+'</span><span class="c-header__level__legende">Questions</span>';
      $infoBoxQuestion.innerHTML = currentQuizData.question;

      $infoBoxImage.innerHTML="<svg class='c-icon' width='100px' height='100px' ><use xlink:href='./assets/images/sprite.svg#"+currentQuizData.icon+"'></use></svg>";
      $infoBoxRound.innerText=currentQuiz+1;



      if(currentQuizData){
        for (let i = 0; i < $options.length; i++) {
          let createLetter;
          switch (i) {
            case 0:
              createLetter="c";
              break;
            case 1:
              createLetter="a";
              break;
            case 2:
              createLetter="b";
              break;
            case 3:
              createLetter="c";
              break;
            case 4:
              createLetter="a";
              break;
          }

          let $option=$options[i];
          populated($option,createLetter);
        }
        getSelection();
        slider();
      }
    }


    $buttonValide.addEventListener("click",function(){
    $selectedElement=document.querySelector(".act");
      if(currentQuizData.correct===selectedId){
        feedback="positive";
      }
      else{
        feedback="negative";
      }

      $popUp.classList.add("s-feedback--"+feedback);
      openFeedback();
    })

    function closeFeedback(){
      $overlay.style.opacity="0";
      $overlay.style.pointerEvents="none";
      $popUp.style.display="none";
      $popUp.className="c-popUp";
    }

    function valideQuestion(){
      if(feedback==="positive"){
        currentQuiz++;
        if(currentQuiz < (quiz_Data.length)){
          mount()
        }else{
          document.querySelector("body").innerHTML="";
          window.location.replace("./end.html");
        }
      }
    }

    function openFeedback(){
      $overlay.style.opacity="0.9";
      $overlay.style.pointerEvents="auto";
      $popUpName.innerHTML="<span class='s-dash'>Vous avez répondu :</span><span>"+person_Data[selectedPersonId-1].nom+", </span>"+person_Data[selectedPersonId-1].role;
      setTimeout(function() {
        $popUp.style.display="flex";
      }, 500);
      if(feedback==="negative"){
        $popUpHeadline.innerText="Et non...";
        $popUpText.innerText=currentQuizData["text"+selectedId];
        $popUpButton.innerText="Rejouer";
        $buttonSkipQuestion.style.display="block";
        if(currentQuiz === (quiz_Data.length-1)){
          $buttonSkipQuestion.style.display="none";
        }

      }else{
        $popUpHeadline.innerText="Bonne réponse !";
        $popUpText.innerText=currentQuizData["text"+selectedId];
        $popUpButton.innerText="Question suivante";
        $buttonSkipQuestion.style.display="none";
        if(currentQuiz === (quiz_Data.length-1)){
          $popUpButton.innerText="Continuer";
        }else{
          $popUpButton.innerText="Question suivante";
        }
      }
    }

    $popUpButton.addEventListener("click",function(){
        closeFeedback();
        valideQuestion();
      });

    function succses(){
      $popUp.style.display="flex";
      $popUpText.innerText="";
      $popUpButton.remove();
    }

    $buttonSkipQuestion.addEventListener("click",function(){
      closeFeedback();
      skipQuestion();
    })

    function skipQuestion(){
      currentQuiz++;
      mount()
    }



    // Slider start

    function slider(){

      let swipe = new Hammer(document.querySelector(".swipe"));

      swipe.on("swipeleft", (ev) => {
          next();
      });

      swipe.on("swiperight", (ev) => {
          prev();
      });
    }

    $buttonNext.addEventListener("click",function(){
      next();
    });

    $buttonPrev.addEventListener("click",function(){
      prev();
    });



    $optionBox.onclick = event => {
      selectOnClick(event.target);
    }

    function selectOnClick(element){
      if (element.classList.contains('next')) {
        next();

      } else if (element.classList.contains('prev')) {
        prev();
      }
    }

    function next() {
      if (document.querySelector(".hide")) {
        document.querySelector(".hide").remove();
      }

      /* Step */

      if (document.querySelector(".prev")) {
        document.querySelector(".prev").classList.add("hide");
        document.querySelector(".prev").classList.remove("prev");
      }


      document.querySelector(".act").classList.add("prev");
      document.querySelector(".act").classList.remove("act");
       //ici opacity
      //document.querySelector(".prev").style.transition = "transform 0.5s ease-in 0s, opacity 0.5s ease-in 0.1s";

      document.querySelector(".next").classList.add("act");
      document.querySelector(".next").classList.remove("next");

      /* New Next */

      document.querySelector(".new-next").classList.remove("new-next");

      let addedEl = document.createElement('li');

      document.querySelector(".o-cluster").appendChild(addedEl);
      addedEl.classList.add("next","new-next");
      getActiveSlide();
      addedEl.id=numberNext;
      let newPersonId = currentQuizData[numberNext];
      addedEl.style.backgroundImage = "url('"+personData[newPersonId-1].image+"')";
      addedEl.setAttribute("role", "img");
      addedEl.setAttribute("aria-label", personData[selectedPersonId-1].nom);
      getSelection();
    }

    function prev() {
      document.querySelector(".new-next").remove();

      /* Step */

      document.querySelector(".next").classList.add("new-next");

      //ici opacity bug
      document.querySelector(".act").classList.add("next");
      document.querySelector(".act").classList.remove("act");
      //document.querySelector(".next").style.transition = "transform 0.5s ease-in 0s, opacity 0.5s ease-in 0.1s";

      document.querySelector(".prev").classList.add("act");
      document.querySelector(".prev").classList.remove("prev");

      /* New Prev */

      document.querySelector(".hide").classList.add("prev");
      document.querySelector(".hide").classList.remove("hide");

      let addedEl = document.createElement('li');


      document.querySelector(".o-cluster").insertBefore(addedEl, document.querySelector(".o-cluster").firstChild);
      addedEl.classList.add("hide");
      getActiveSlide();
      addedEl.id=numberPrev;
      let newPersonId = currentQuizData[numberPrev];
      addedEl.style.backgroundImage = "url('"+personData[newPersonId-1].image+"')";
      addedEl.setAttribute("role", "img");
      addedEl.setAttribute("aria-label", personData[selectedPersonId-1].nom);
      getSelection()
    }


    function getActiveSlide(){

      number = document.querySelector(".act").id;

      if(number === "a"){
        numberNext="c";
        numberPrev="b";
      }else if(number === "b"){
        numberNext="a";
        numberPrev="c";
      }else{
        numberNext="b";
        numberPrev="a";
      }
    }

    // Slider end



    }
    else if(document.querySelector("body").className==="intro"){

      setTimeout(function() {
        document.querySelector(".c-intro").classList.add("is-over");
        document.querySelector(".c-introYear__bg").style.opacity="0";
      }, 7200);

      let $buttonScrollDown= document.querySelector(".js-button-scrollDown");
      $buttonScrollDown.addEventListener("click",function(){
        //window.scrollBy(0,viewportHeight);
        window.scrollBy({
          top: viewportHeight,
          behavior: 'smooth'
        });
      })

      let $buttonScrollEnd= document.querySelector(".js-button-scrollEnd");
      $buttonScrollEnd.addEventListener("click",function(){
        document.querySelector("main").classList.add("is_opend");
        document.querySelector(".o-section--hidden").classList.add("is_opend")
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
      })

      if(!!window.IntersectionObserver){
        let observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
          if(entry.isIntersecting){
            entry.target.classList.add("is-inViewport");
            observer.unobserve(entry.target);
          }
          });
        }, {rootMargin: "0px 0px -"+((viewportHeight/100)*30)+"px 0px"});
        document.querySelectorAll('.js-observed-section').forEach(section => { observer.observe(section) });
      }

      else {
        document.querySelector("body").classList.add("no-observer");
        document.querySelectorAll('.js-observed-section').forEach(section => {
          section.classList.add("is-inViewport");
        });
      }


      var rellax = new Rellax(".rellax");


    }
    else{
      if(!!window.IntersectionObserver){
        let observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
          if(entry.isIntersecting){
            entry.target.classList.add("is-inViewport");
            //entry.target.style.backgroundColor="red";
            observer.unobserve(entry.target);
          }
          });
        }, {rootMargin: "0px 0px -"+((viewportHeight/100)*20)+"px 0px"});
        document.querySelectorAll('.js-observed-section').forEach(section => { observer.observe(section) });
      }

      else {
        document.querySelector("body").classList.add("no-observer");
        document.querySelectorAll('.js-observed-section').forEach(section => {
          section.classList.add("is-inViewport");
        });
      }

      var rellax = new Rellax(".rellax");


    }

  });
})();
